<style scoped lang="sass">
@use '../../styles/variables.scss' as *

.maintenance-wrapper
  position: relative
  display: flex
  justify-content: center
  align-items: center
  min-height: 100vh
  padding: 16px
  background: $white-grey
  overflow: hidden

// Misma franja diagonal que el login
.line-design
  position: absolute
  width: 100%
  height: 20rem
  bottom: 0
  left: 0
  background: #8CA695
  clip-path: polygon(0% 0%, 100% 20%, 100% 100%, 0% 100%)
</style>

<template>
  <div class="maintenance-wrapper">
    <div class="line-design"></div>

    <maintenance-card
      :title="$t('Sistema en mantenimiento')"
      :message="$t(
        'Estamos realizando trabajos de mantenimiento para mejorar el servicio. '
          + 'Por favor, intente más tarde.',
      )"
      :status="$t(
        'Esta página se actualizará automáticamente cuando el sistema '
          + 'vuelva a estar disponible.',
      )"
    />
  </div>
</template>

<script setup>
import MaintenanceCard from '@/components/maintenance/MaintenanceCard.vue';
</script>
